import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import APP_CONFIG, { getAppTitle } from '../config/appConfig';

const TRANSPORT_PAGE_TITLES = {
  rides: 'Corridas',
  boardings: 'Embarques',
  drivers: 'Motoristas',
  vehicles: 'Veículos',
  patients: 'Passageiros',
  cities: 'Cidades',
  facilities: 'Estabelecimentos',
  specialties: 'Especialidades',
  distances: 'Distâncias',
  reports: 'Relatórios',
};

const PAGE_TITLES = {
  '/': null,
  '/login': 'Login',
  '/usuarios': 'Usuários',
  '/boletim/producao-bpa': 'Produção BPA',
  '/boletim/gera-bpa': 'Gera BPA',
  '/boletim/pacientes-incompletos': 'Pacientes Incompletos',
  '/bpa/viagem': 'BPA Transporte',
  '/boletim/bpa-transporte': 'BPA Transporte',
};

function pageTitleFromPath(pathname) {
  if (PAGE_TITLES[pathname] !== undefined) {
    return PAGE_TITLES[pathname];
  }

  if (pathname.startsWith('/transport/')) {
    const resource = pathname.split('/').filter(Boolean).pop();
    return TRANSPORT_PAGE_TITLES[resource] || 'Transporte';
  }

  if (pathname.startsWith('/transport')) {
    return 'Transporte';
  }

  return null;
}

export function getDocumentTitle(pathname) {
  const appTitle = getAppTitle();
  const page = pageTitleFromPath(pathname);
  return page ? `${page} · ${appTitle}` : appTitle;
}

export default function DocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    document.title = getDocumentTitle(location.pathname);

    if (APP_CONFIG.DESCRIPTION) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', APP_CONFIG.DESCRIPTION);
    }
  }, [location.pathname]);

  return null;
}
